import { Box, Typography } from '@mui/material';

import { FORTA_GRAY4, FORTA_GRAY3, FORTA_WHITE } from '../../utils/colors';
import FHSkeletonLoader from './FHSkeletonLoader';

interface IFHKeyValueProps {
  label: string;
  value?: string;
  values?: string[];
  emptyStateText?: string;
  pointerColor?: string;
  fontcolor?: string;
  sx?: any;
  loading?: boolean;
  isUnorderedList?: boolean;
}

const FHKeyValue = (props: IFHKeyValueProps) => {
  const {
    pointerColor = FORTA_GRAY3,
    fontcolor = FORTA_GRAY4,
    sx = {},
    label = '',
    value = '',
    values = [],
    isUnorderedList = false,
    emptyStateText = 'N/A',
    loading,
  } = props;

  return (
    <Box
      sx={{
        px: 2,
        py: 1,
        mb: 1,
        borderRadius: '4px',
        // boxShadow: '0 2px 2px rgba(0, 0, 0, 0.1)',
        backgroundColor: FORTA_WHITE,
        ...sx,
      }}
    >
      <Box sx={{ mb: 0.1 }}>
        <Typography fontWeight={700} fontSize={14} color={fontcolor}>
          {label}
        </Typography>
      </Box>
      {loading ? (
        <FHSkeletonLoader containerStyles={{}} />
      ) : value ? (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography sx={{ wordWrap: 'break-word' }} display={'inline'} mr={1}>
              {value}
            </Typography>
          </Box>
        </Box>
      ) : values && values?.length > 0 ? (
        values.map((value, i) => (
          <Box sx={{ display: 'flex', alignItems: 'center' }} id={i + ''} key={i}>
            {!isUnorderedList && (
              <Box
                sx={{
                  backgroundColor: pointerColor,
                  minWidth: '10px',
                  minHeight: '10px',
                  borderRadius: '50%',
                  mr: 1,
                }}
              ></Box>
            )}
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography sx={{ wordWrap: 'break-word' }} display={'inline'} mr={1}>
                {value}
              </Typography>
            </Box>
          </Box>
        ))
      ) : (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography sx={{ wordWrap: 'break-word' }} display={'inline'} mr={1}>
              {emptyStateText}
            </Typography>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default FHKeyValue;
